import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getPopulatesPropsSettingsConfigFormly,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  doubleIdInputFieldParseIntoSettingsFormModel,
  doubleIdInputFieldUpdateFromSettingsFormModel,
  getDoubleIdInputFieldSettingsConfig,
} from '../double-id-field-type.configurator';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomDoubleIdInputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      doubleIdInputFieldContentConfig: {
        url: '/integration/v1/fetch/sync',
        useBaseUrl: true,
        endpointCode: '',
        allowedDocumentTypes: [],
        firstIdentityLabel: '',
        firstIdentityPlaceholder: '',
        firstIdentityValueKey: '',
        firstIdentityDocumentTypeKey: '',
        secondIdentityLabel: '',
        secondIdentityPlaceholder: '',
        secondIdentityValueKey: '',
        secondIdentityDocumentTypeKey: '',
      },
    };
    this.settingsFormlyForm = [
      ...getDoubleIdInputFieldSettingsConfig(),
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, []),
    ];
    this.availableValidations.push('invalidInput');
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return doubleIdInputFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return doubleIdInputFieldUpdateFromSettingsFormModel(this.field, model);
  }
}
